import { render, staticRenderFns } from "./TemplateEmail.vue?vue&type=template&id=a098cf50&scoped=true&"
import script from "./TemplateEmail.vue?vue&type=script&lang=js&"
export * from "./TemplateEmail.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEmail.vue?vue&type=style&index=0&id=a098cf50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a098cf50",
  null
  
)

export default component.exports